export const categories = [
  "Alerts",
  "Appointment management",
  "Asset Management",
  "Business continuity",
  "Debt recovery",
  "Duty of Care",
  "Escalations",
  "Incidents",
  "Machine2machine",
  "Notifications",
  "Recruitment",
  "Reporting",
  "Resource management",
  "Support",
  "Ticketing",
  "Transport",
  "Weather",
  "Welfare",
];

export const campaignCategories = [
  "Administration",
  "Feedback",
  "Information",
  "Marketing",
  "Registration",
  "Reporting",
  "Support",
  "Survey",
];

// export const industryTypes = [
//   { value: "A", label: "Agriculture, forestry and fishing" },
//   { value: "B", label: "Mining and quarrying" },
//   { value: "C", label: "Manufacturing" },
//   { value: "D", label: "Electricity, gas, steam and air conditioning supply" },
//   {
//     value: "E",
//     label:
//       "Water supply; sewerage, waste management and remediation activities",
//   },
//   { value: "F", label: "Construction" },
//   {
//     value: "G",
//     label:
//       "Wholesale and retail trade; repair of motor vehicles and motorcycles",
//   },
//   { value: "H", label: "Transportation and storage" },
//   { value: "I", label: "Accommodation and food service activities" },
//   { value: "J", label: "Information and communication" },
//   { value: "K", label: "Financial and insurance activities" },
//   { value: "L", label: "Real estate activities" },
//   { value: "M", label: "Professional, scientific and technical activities" },
//   { value: "N", label: "Administrative and support service activities" },
//   {
//     value: "O",
//     label: "Public administration and defence; compulsory social security",
//   },
//   { value: "P", label: "Education" },
//   { value: "Q", label: "Human health and social work activities" },
//   { value: "R", label: "Arts, entertainment and recreation" },
//   { value: "S", label: "Other service activities" },
//   {
//     value: "T",
//     label:
//       "Activities of households as employers; undifferentiated goods and services-producing activities of households for own use",
//   },
// ];

export const industryTypes = [
  "Accommodation and food service activities",
  "Activities of households as employers; undifferentiated goods and services-producing activities of households for own use",
  "Administrative and support service activities",
  "Agriculture, forestry and fishing",
  "Arts, entertainment and recreation",
  "Construction",
  "Education",
  "Electricity, gas, steam and air conditioning supply",
  "Financial and insurance activities",
  "Human health and social work activities",
  "Information and communication",
  "Manufacturing",
  "Mining and quarrying",
  "Other service activities",
  "Professional, scientific and technical activities",
  "Public administration and defence; compulsory social security",
  "Real estate activities",
  "Transportation and storage",
  "Water supply; sewerage, waste management and remediation activities",
  "Wholesale and retail trade; repair of motor vehicles and motorcycles",
];
